import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';

type LoggingTestResult = {
  service: string;
  endpoint: string;
  success: boolean;
  message: string;
  timestamp: string;
  details?: any;
};

@Component({
  selector: 'app-logging-tests',
  templateUrl: './logging-tests.component.html',
  styleUrls: ['./logging-tests.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoggingTestsComponent implements OnInit, OnDestroy {
  webApiBaseUrl = environment.dotNetApiUrl;
  reportingBaseUrl = environment.reportingServiceUrl;

  // Individual test loading states
  webApiLoggingLoading = false;
  reportingLoggingLoading = false;

  // Individual test results
  webApiLoggingResult: LoggingTestResult | null = null;
  reportingLoggingResult: LoggingTestResult | null = null;

  // Subscription management
  private subscriptions: Subscription[] = [];

  constructor(private httpClient: HttpClient) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    // Clean up all subscriptions to prevent memory leaks
    this.subscriptions.forEach(subscription => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
    this.subscriptions = [];
  }

  testWebApiLogging(): void {
    this.webApiLoggingLoading = true;
    this.webApiLoggingResult = null; // Clear previous result
    const url = `${this.webApiBaseUrl}/test/logging`;

        const subscription = this.httpClient
            .get(url, { responseType: 'text' })
            .subscribe({
                next: (response) => {
                    this.webApiLoggingResult = {
                    service: 'WebAPI',
                    endpoint: '/test/logging',
                    success: true,
                    message: `Success - ${response}`,
                    timestamp: new Date().toISOString(),
                    details: response
                    };
                    this.webApiLoggingLoading = false;
                },
                error: (error) => {
                    this.webApiLoggingResult = {
                    service: 'WebAPI',
                    endpoint: '/test/logging',
                    success: false,
                    message: `Error: ${error.message || 'Unknown error'}`,
                    timestamp: new Date().toISOString(),
                    details: error
                    };
                    this.webApiLoggingLoading = false;
                }
            });

        this.subscriptions.push(subscription);
    }

  testReportingLogging(): void {
    this.reportingLoggingLoading = true;
    this.reportingLoggingResult = null; // Clear previous result
    const url = `${this.reportingBaseUrl}/test/logging`;

    const subscription = this.httpClient
        .get(url, { responseType: 'text' })
        .subscribe({
            next: (response) => {
                this.reportingLoggingResult = {
                service: 'Reporting',
                endpoint: '/test/logging',
                success: true,
                message: `Success - ${response}`,
                timestamp: new Date().toISOString(),
                details: response
                };
                this.reportingLoggingLoading = false;
            },
            error: (error) => {
                this.reportingLoggingResult = {
                service: 'Reporting',
                endpoint: '/test/logging',
                success: false,
                message: `Error: ${error.message || 'Unknown error'}`,
                timestamp: new Date().toISOString(),
                details: error
                };
                this.reportingLoggingLoading = false;
            }
        });

        this.subscriptions.push(subscription);
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/logging-tests/logging-tests.component.ts